import { useState } from "react";
import { saveTaxCodeDetails } from "../Api/TaxCodeLogistics";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const TaxCodeLogistics = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [taxCodeData, setTaxCodeData] = useState({
    code: "",
    description: "",
    type: "",
    cgst: 0,
    sgst: 0,
    igst: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTaxCodeData({
      ...taxCodeData,
      [name]:
        name === "cgst" || name === "sgst" || name === "igst"
          ? parseFloat(value)
          : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveTaxCodeDetails(taxCodeData, userId);
      toast.success(`🦄 Tax Code Added Successfully`);
      setTaxCodeData({
        code: "",
        description: "",
        type: "",
        cgst: 0,
        sgst: 0,
        igst: 0,
      });
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save tax code"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container gl-master-fields">
        <h2 className="fields-title">Tax Code Logistics</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0" className="gl-master-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        value={taxCodeData.code}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Description <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={taxCodeData.description}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Type <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="type"
                        value={taxCodeData.type}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        CGST (%) <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="cgst"
                        value={taxCodeData.cgst}
                        onChange={handleChange}
                        step="0.01"
                        min="0"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        SGST (%) <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="sgst"
                        value={taxCodeData.sgst}
                        onChange={handleChange}
                        step="0.01"
                        min="0"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        IGST (%) <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="igst"
                        value={taxCodeData.igst}
                        onChange={handleChange}
                        step="0.01"
                        min="0"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit">
              Save Tax Code
            </Button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default TaxCodeLogistics;
